import type { NextPage } from "next"
import type { ErrorProps } from "next/error"

import Error from "~/pages/_error"

type PropsWithoutError<P> = P & { error: never }

export type ErrorFallback<
  P extends Record<string, unknown>,
  E extends ErrorProps = ErrorProps,
> = React.FC<{ error: E } | PropsWithoutError<P>>

export function withErrorFallback<
  P extends Record<string, unknown>,
  E extends ErrorProps = ErrorProps,
>(Component: NextPage<P>): ErrorFallback<P, E> {
  return (props) => {
    if ("error" in props) {
      const { error } = props

      return <Error statusCode={error.statusCode || 500} />
    }

    return <Component {...(props as P)} />
  }
}
